var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 185.25,
    height: 166.497,
    viewBox: "0 0 185.25 166.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1871",
    "data-name": "\\uADF8\\uB8F9 1871",
    transform: "translate(-876.75 -240.841)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_143",
    "data-name": "\\uD0C0\\uC6D0 143",
    cx: 59,
    cy: 66,
    rx: 59,
    ry: 66,
    transform: "translate(902 261)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-account-circle",
    "data-name": "Icon material-account-circle",
    d: "M86.248,3A83.248,83.248,0,1,0,169.5,86.248,83.279,83.279,0,0,0,86.248,3Zm0,24.974A24.974,24.974,0,1,1,61.274,52.949,24.941,24.941,0,0,1,86.248,27.974Zm0,118.213A59.943,59.943,0,0,1,36.3,119.381c.25-16.566,33.3-25.64,49.949-25.64,16.566,0,49.7,9.074,49.949,25.64a59.943,59.943,0,0,1-49.949,26.806Z",
    transform: "translate(873.75 237.841)",
    fill: "#008aff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1246",
    "data-name": "\\uADF8\\uB8F9 1246",
    transform: "translate(-21 89.695)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_142",
    "data-name": "\\uD0C0\\uC6D0 142",
    cx: 36.5,
    cy: 36.5,
    r: 36.5,
    transform: "translate(1010 244.305)",
    fill: "#161d27"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1030",
    "data-name": "\\uADF8\\uB8F9 1030",
    transform: "translate(1016.183 250.426)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_111",
    "data-name": "\\uD0C0\\uC6D0 111",
    transform: "translate(6.375 9)",
    fill: "#fff",
    stroke: "#161d27",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.896,
    cy: 21.896,
    rx: 24.896,
    ry: 21.896,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.896,
    cy: 21.896,
    rx: 23.396,
    ry: 20.396,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-checkmark-circle",
    "data-name": "Icon ionic-ios-checkmark-circle",
    d: "M34.271,3.375a30.9,30.9,0,1,0,30.9,30.9A30.891,30.891,0,0,0,34.271,3.375ZM50.09,25.73,30.231,45.679h-.015a2.683,2.683,0,0,1-1.723.817,2.6,2.6,0,0,1-1.738-.847l-8.318-8.318a.592.592,0,0,1,0-.847l2.644-2.644a.574.574,0,0,1,.832,0l6.6,6.6L46.629,22.18A.586.586,0,0,1,47.045,22h0a.539.539,0,0,1,.416.178l2.6,2.689A.586.586,0,0,1,50.09,25.73Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#00b235"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountProfile);
export default __webpack_public_path__ + "static/media/account_profile.7a681e2d751988bed23c1e4eef1d35e5.svg";
export { ForwardRef as ReactComponent };